"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Edit = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Edit"));

// Generated by script, don't edit it please.
var Edit = (0, _createSvgIcon["default"])({
  as: _Edit["default"],
  ariaLabel: 'edit',
  category: 'action',
  displayName: 'Edit'
});
var _default = Edit;
exports["default"] = _default;
module.exports = exports.default;